"use strict";

var _regeneratorRuntime = require("/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

require("core-js/modules/es.array.flat-map.js");

require("core-js/modules/es.array.unscopables.flat-map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stream = exports.Stream = void 0;

var StreamHelpers_1 = require("./StreamHelpers");

var Stream = /*#__PURE__*/function (_Symbol$iterator) {
  function Stream(g) {
    _classCallCheck(this, Stream);

    this.g = g;
  }

  _createClass(Stream, [{
    key: "next",
    value: function next() {
      return this.g.next();
    }
  }, {
    key: _Symbol$iterator,
    value: function value() {
      return this.g;
    }
  }, {
    key: "map",
    value: function map(f) {
      return new Stream((0, StreamHelpers_1.mapHelper)(this.g, f));
    }
  }, {
    key: "flatMap",
    value: function flatMap(f) {
      return new Stream((0, StreamHelpers_1.flatMapHelper)(this.g, f));
    }
  }, {
    key: "dropWhile",
    value: function dropWhile(f) {
      var _marked = /*#__PURE__*/_regeneratorRuntime.mark(helper);

      var foundEligible = false;

      function helper(v) {
        return _regeneratorRuntime.wrap(function helper$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(foundEligible || !f(v))) {
                  _context.next = 4;
                  break;
                }

                foundEligible = true;
                _context.next = 4;
                return v;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _marked);
      }

      return this.flatMap(helper);
    }
  }, {
    key: "drop",
    value: function drop(n) {
      var idx = 0;

      function helper() {
        return idx++ < n;
      }

      return this.dropWhile(helper);
    }
  }, {
    key: "takeWhile",
    value: function takeWhile(f) {
      return new Stream((0, StreamHelpers_1.takeWhileHelper)(this.g, f));
    }
  }, {
    key: "take",
    value: function take(n) {
      return new Stream((0, StreamHelpers_1.takeNHelper)(this.g, n));
    }
  }, {
    key: "filter",
    value: function filter(f) {
      return new Stream((0, StreamHelpers_1.filterHelper)(this.g, f));
    }
  }, {
    key: "every",
    value: function every(f) {
      var _iterator = _createForOfIteratorHelper(this.g),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var v = _step.value;

          if (!f(v)) {
            return false;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return true;
    }
  }, {
    key: "has",
    value: function has(f) {
      var _iterator2 = _createForOfIteratorHelper(this.g),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var v = _step2.value;

          if (f(v)) {
            return [true, v];
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return [false, null];
    }
  }, {
    key: "join",
    value: function join() {
      for (var _len = arguments.length, others = new Array(_len), _key = 0; _key < _len; _key++) {
        others[_key] = arguments[_key];
      }

      return new Stream((0, StreamHelpers_1.joinHelper)(this.g, others));
    }
  }, {
    key: "getNthOrLast",
    value: function getNthOrLast(nth) {
      var remaining = nth;
      var last = null;

      var _iterator3 = _createForOfIteratorHelper(this.g),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var v = _step3.value;
          if (remaining-- === 0) return v;
          last = v;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return last;
    }
  }], [{
    key: "nil",
    value: function nil() {
      return new Stream((0, StreamHelpers_1.nilHelper)());
    }
  }, {
    key: "of",
    value: function of() {
      for (var _len2 = arguments.length, elements = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        elements[_key2] = arguments[_key2];
      }

      return new Stream(elements[Symbol.iterator]());
    }
  }]);

  return Stream;
}(Symbol.iterator);

exports.Stream = Stream;

function stream(g) {
  return new Stream(g);
}

exports.stream = stream;